import {
  AppBar,
  Toolbar,
  Button,
  Container,
  MenuItem,
  Hidden,
  Popper,
  Grow,
  Paper,
  MenuList,
  ClickAwayListener,
  ListItem,
  List,
  ListItemText,
  Drawer,
  Typography,
  useTheme,
  useMediaQuery,
  IconButton,
  Box,
  Slide,
  useScrollTrigger,
  makeStyles,
} from "@material-ui/core";
import "bootstrap/dist/css/bootstrap.min.css";
import { UserContext } from "../../contexts/UserContext";
import { useContext, useState, useRef, useEffect, useCallback } from "react";
import { Snackbar } from "@material-ui/core";

import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

import { useNavigate, useLocation, Link } from "react-router-dom";

import MuiAlert from "@material-ui/lab/Alert";

import Axios from "axios";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";

const NAV_ITEMS = [
  { path: "/about-us", label: "About" },
  { path: "/our-services", label: "Services" },
  { path: "/our-products", label: "Products" },
  { path: "/our-team", label: "Team" },
  { path: "/whats-new", label: "What's New" },
  { path: "/careers", label: "Careers" },
];

const useStyles = makeStyles((theme) => ({
  // ── AppBar ──
  appBar: {
    backgroundColor: "rgba(255,255,255,0.72)",
    backdropFilter: "blur(20px) saturate(180%)",
    WebkitBackdropFilter: "blur(20px) saturate(180%)",
    borderBottom: "1px solid rgba(0,0,0,0.06)",
    color: "#4c004c",
    transition: "border-color 0.3s ease, background-color 0.3s ease",
  },
  toolbar: {
    minHeight: 64,
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 24,
  },

  // ── Logo ──
  logoContainer: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    "&, &:hover, &:focus, &:active, &:visited": {
      textDecoration: "none",
    },
  },
  logoWrapper: {
    width: 38,
    height: 38,
    borderRadius: 10,
    overflow: "hidden",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    transition: "transform 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
    "&:hover": {
      transform: "scale(1.05)",
    },
  },
  logo: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    border: "none",
    display: "block",
  },
  brandName: {
    fontSize: "1rem",
    fontWeight: 600,
    color: "#4c004c",
    marginLeft: 12,
    letterSpacing: "-0.2px",
  },

  // ── Sliding Pill Nav ──
  navWrap: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    gap: 0,
    padding: "4px",
    borderRadius: 14,
  },
  navIndicator: {
    position: "absolute",
    top: 4,
    bottom: 4,
    left: 0,
    background: "rgba(76,0,76,0.08)",
    borderRadius: 10,
    transition:
      "transform 0.4s cubic-bezier(0.22, 1, 0.36, 1), width 0.4s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.25s ease",
    pointerEvents: "none",
    zIndex: 0,
  },
  navButton: {
    position: "relative",
    zIndex: 1,
    fontSize: "0.83rem",
    fontWeight: 500,
    padding: "8px 16px",
    borderRadius: 10,
    textTransform: "none",
    minWidth: "auto",
    transition: "color 0.3s ease",
    "&, &:focus, &:active, &:visited": {
      color: "#6b4c6b",
      textDecoration: "none",
    },
    "&:hover": {
      backgroundColor: "transparent",
      color: "#4c004c",
    },
  },
  navButtonActive: {
    "&, &:focus, &:active, &:visited": {
      color: "#4c004c",
      fontWeight: 600,
    },
  },

  // ── Right cluster ──
  rightCluster: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    flexShrink: 0,
  },
  contactButton: {
    backgroundColor: "#4c004c",
    fontSize: "0.83rem",
    fontWeight: 600,
    padding: "8px 18px",
    borderRadius: 22,
    textTransform: "none",
    transition: "all 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
    "&, &:hover, &:focus, &:active, &:visited": {
      color: "#ffffff",
      textDecoration: "none",
    },
    "&:hover": {
      backgroundColor: "#6b1b6b",
      transform: "translateY(-1px)",
      boxShadow: "0 6px 18px rgba(76,0,76,0.3)",
    },
    "& .MuiButton-endIcon": {
      marginLeft: 6,
      transition: "transform 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
      "& svg": { fontSize: 14 },
    },
    "&:hover .MuiButton-endIcon": {
      transform: "translateX(3px)",
    },
  },
  accountButton: {
    color: "#4c004c",
    fontSize: "0.83rem",
    fontWeight: 500,
    padding: "7px 14px",
    borderRadius: 10,
    textTransform: "none",
    border: "1px solid rgba(76,0,76,0.18)",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "rgba(76,0,76,0.05)",
      borderColor: "rgba(76,0,76,0.35)",
    },
  },
  accountMenu: {
    "& .MuiPaper-root": {
      borderRadius: 14,
      boxShadow: "0 12px 40px rgba(0,0,0,0.12)",
      marginTop: 12,
      minWidth: 200,
      border: "1px solid rgba(0,0,0,0.04)",
      overflow: "hidden",
    },
  },
  accountMenuItem: {
    padding: "12px 18px",
    fontSize: "0.88rem",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "rgba(76,0,76,0.05)",
    },
  },

  // ── Mobile menu trigger ──
  menuButton: {
    color: "#4c004c",
    padding: 8,
    borderRadius: 10,
    border: "1px solid rgba(0,0,0,0.08)",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.04)",
      borderColor: "rgba(0,0,0,0.15)",
    },
  },

  // ── Full-screen drawer ──
  drawer: {
    "& .MuiDrawer-paper": {
      width: "100vw",
      maxWidth: "100vw",
      height: "100vh",
      background: "#ffffff",
      overflow: "hidden",
    },
    "& .MuiBackdrop-root": {
      backgroundColor: "rgba(26,0,26,0.5)",
    },
  },
  drawerInner: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    position: "relative",
  },
  drawerBgAccent: {
    position: "absolute",
    top: -200,
    right: -200,
    width: 500,
    height: 500,
    borderRadius: "50%",
    background:
      "radial-gradient(circle, rgba(199,125,199,0.18), transparent 65%)",
    filter: "blur(40px)",
    pointerEvents: "none",
  },
  drawerBgAccent2: {
    position: "absolute",
    bottom: -200,
    left: -200,
    width: 500,
    height: 500,
    borderRadius: "50%",
    background:
      "radial-gradient(circle, rgba(76,0,76,0.12), transparent 65%)",
    filter: "blur(40px)",
    pointerEvents: "none",
  },
  drawerHeader: {
    position: "relative",
    zIndex: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "18px 24px",
    [theme.breakpoints.up("sm")]: {
      padding: "20px 36px",
    },
  },
  drawerCloseBtn: {
    color: "#4c004c",
    width: 40,
    height: 40,
    border: "1px solid rgba(0,0,0,0.08)",
    transition: "all 0.4s cubic-bezier(0.22, 1, 0.36, 1)",
    "&:hover": {
      background: "rgba(0,0,0,0.04)",
      transform: "rotate(90deg)",
    },
  },
  "@keyframes drawerLinkRise": {
    from: { opacity: 0, transform: "translateY(20px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  drawerNav: {
    position: "relative",
    zIndex: 2,
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "0 28px",
    gap: 4,
    [theme.breakpoints.up("sm")]: {
      padding: "0 48px",
    },
  },
  drawerLink: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px 4px",
    borderBottom: "1px solid rgba(0,0,0,0.06)",
    textDecoration: "none",
    transition: "all 0.4s cubic-bezier(0.22, 1, 0.36, 1)",
    opacity: 0,
    animation:
      "$drawerLinkRise 0.6s cubic-bezier(0.22, 1, 0.36, 1) forwards",
    "&, &:hover, &:focus, &:active, &:visited": {
      textDecoration: "none",
    },
    "&:hover $drawerLinkText": {
      transform: "translateX(8px)",
      color: "#4c004c",
    },
    "&:hover $drawerLinkArrow": {
      opacity: 1,
      transform: "translateX(0)",
      color: "#4c004c",
    },
  },
  drawerLinkActive: {
    "& $drawerLinkText": {
      color: "#4c004c",
    },
    "& $drawerLinkArrow": {
      opacity: 1,
      transform: "translateX(0)",
      color: "#4c004c",
    },
  },
  drawerLinkText: {
    fontSize: "1.6rem",
    fontWeight: 500,
    color: "#4c004c",
    letterSpacing: "-0.02em",
    lineHeight: 1.2,
    transition: "all 0.4s cubic-bezier(0.22, 1, 0.36, 1)",
    [theme.breakpoints.up("sm")]: {
      fontSize: "2rem",
    },
  },
  drawerLinkArrow: {
    color: "#bbbbbb",
    fontSize: 22,
    opacity: 0,
    transform: "translateX(-12px)",
    transition: "all 0.4s cubic-bezier(0.22, 1, 0.36, 1)",
  },
  drawerFooter: {
    position: "relative",
    zIndex: 2,
    padding: "20px 28px 28px",
    borderTop: "1px solid rgba(0,0,0,0.06)",
    display: "flex",
    flexDirection: "column",
    gap: 12,
    [theme.breakpoints.up("sm")]: {
      padding: "24px 48px 32px",
    },
  },
  drawerContactButton: {
    backgroundColor: "#4c004c",
    color: "#ffffff",
    borderRadius: 14,
    padding: "16px 20px",
    textTransform: "none",
    fontSize: "0.95rem",
    fontWeight: 600,
    width: "100%",
    boxSizing: "border-box",
    transition: "all 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
    "&, &:hover, &:focus, &:active, &:visited": {
      color: "#ffffff",
      textDecoration: "none",
    },
    "&:hover": {
      backgroundColor: "#6b1b6b",
      transform: "translateY(-1px)",
      boxShadow: "0 8px 22px rgba(76,0,76,0.32)",
    },
    "& .MuiButton-endIcon": {
      transition: "transform 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
    },
    "&:hover .MuiButton-endIcon": {
      transform: "translateX(4px)",
    },
  },
  drawerAccount: {
    position: "relative",
    zIndex: 2,
    padding: "16px 28px",
    borderTop: "1px solid rgba(0,0,0,0.06)",
    [theme.breakpoints.up("sm")]: {
      padding: "16px 48px",
    },
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function HideOnScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({ target: window ? window() : undefined });
  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

export const NavBar = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  let navigate = useNavigate();
  const location = useLocation();
  const { user, setUser } = useContext(UserContext);

  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const anchorRef1 = useRef(null);
  const [open1, setOpen1] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const [snackBar, setSnackBar] = useState(false);
  const [snackBarMsg, setSnackBarMsg] = useState("success");
  const [snackBarType, setSnackBarType] = useState("Invalid");

  const isActive = (path) => location.pathname === path;
  const closeDrawer = () => setDrawerOpen(false);

  // ── Sliding pill indicator ──
  const navWrapRef = useRef(null);
  const itemRefs = useRef([]);
  const [indicator, setIndicator] = useState({ left: 0, width: 0, opacity: 0 });

  const moveIndicatorTo = useCallback((idx) => {
    const el = itemRefs.current[idx];
    const wrap = navWrapRef.current;
    if (!el || !wrap) return;
    const elRect = el.getBoundingClientRect();
    const wrapRect = wrap.getBoundingClientRect();
    setIndicator({
      left: elRect.left - wrapRect.left,
      width: elRect.width,
      opacity: 1,
    });
  }, []);

  const syncIndicatorToActive = useCallback(() => {
    const activeIdx = NAV_ITEMS.findIndex((it) => it.path === location.pathname);
    if (activeIdx >= 0) {
      moveIndicatorTo(activeIdx);
    } else {
      setIndicator((prev) => ({ ...prev, opacity: 0 }));
    }
  }, [location.pathname, moveIndicatorTo]);

  useEffect(() => {
    // small delay so refs are populated
    const t = setTimeout(syncIndicatorToActive, 50);
    return () => clearTimeout(t);
  }, [syncIndicatorToActive]);

  useEffect(() => {
    const onResize = () => syncIndicatorToActive();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [syncIndicatorToActive]);

  const handleToggle = () => setOpen((p) => !p);
  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) return;
    setOpen(false);
  };
  const handleListKeyDown = (event) => {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  };

  const handleToggle1 = () => setOpen1((p) => !p);
  const handleClose1 = (event) => {
    if (anchorRef1.current && anchorRef1.current.contains(event.target)) return;
    closeDrawer();
    setOpen1(false);
  };
  const handleListKeyDown1 = (event) => {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen1(false);
    }
  };

  const openSnkbar = (type, msg) => {
    setSnackBarMsg(msg);
    setSnackBarType(type);
    setSnackBar(true);
  };

  const logout = () => {
    Axios.get("/api/logout", { headers: { headKey: headKey } }).then((res) => {
      if (res.data.status) {
        openSnkbar("success", res.data.msg);
        setUser(null);
        setOpen(false);
        closeDrawer();
        navigate("/");
      }
    });
  };

  return (
    <HideOnScroll {...props}>
      <AppBar
        position="sticky"
        id="back-to-top-anchor"
        elevation={0}
        className={classes.appBar}
      >
        <Container maxWidth="xl">
          <Snackbar
            open={snackBar}
            autoHideDuration={4000}
            onClose={() => setSnackBar(false)}
          >
            <Alert
              onClose={() => setSnackBar(false)}
              severity={snackBarType}
              style={{ color: snackBarType === "warning" ? "black" : "white" }}
            >
              {snackBarMsg}
            </Alert>
          </Snackbar>

          <Toolbar className={classes.toolbar} disableGutters>
            {/* Left: logo + brand */}
            <Link to="/" className={classes.logoContainer}>
              <Box className={classes.logoWrapper}>
                <img
                  src="/static/logo.png"
                  alt="Arawinz logo"
                  className={classes.logo}
                />
              </Box>
              <Hidden mdDown>
                <Typography className={classes.brandName}>
                  Arawinz Soft Solutions
                </Typography>
              </Hidden>
            </Link>

            {/* Center: nav with sliding pill (desktop only) */}
            <Hidden mdDown>
              <Box
                ref={navWrapRef}
                className={classes.navWrap}
                onMouseLeave={syncIndicatorToActive}
              >
                <Box
                  className={classes.navIndicator}
                  style={{
                    transform: `translateX(${indicator.left}px)`,
                    width: indicator.width,
                    opacity: indicator.opacity,
                  }}
                />
                {NAV_ITEMS.map((item, idx) => (
                  <Button
                    key={item.path}
                    ref={(el) => (itemRefs.current[idx] = el)}
                    component={Link}
                    to={item.path}
                    onMouseEnter={() => moveIndicatorTo(idx)}
                    className={`${classes.navButton} ${
                      isActive(item.path) ? classes.navButtonActive : ""
                    }`}
                  >
                    {item.label}
                  </Button>
                ))}
              </Box>
            </Hidden>

            {/* Right cluster */}
            <Box className={classes.rightCluster}>
              {/* Desktop CTA + account */}
              <Hidden mdDown>
                <Button
                  component={Link}
                  to="/get-in-touch"
                  className={classes.contactButton}
                  endIcon={<ArrowForwardIcon />}
                >
                  Contact
                </Button>

                {user && (
                  <>
                    <Button
                      ref={anchorRef}
                      onClick={handleToggle}
                      className={classes.accountButton}
                      endIcon={<KeyboardArrowDownIcon />}
                    >
                      Account
                    </Button>
                    <Popper
                      open={open}
                      anchorEl={anchorRef.current}
                      role={undefined}
                      transition
                      disablePortal
                      className={classes.accountMenu}
                    >
                      {({ TransitionProps, placement }) => (
                        <Grow
                          {...TransitionProps}
                          style={{
                            transformOrigin:
                              placement === "bottom"
                                ? "center top"
                                : "center bottom",
                          }}
                        >
                          <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                              <MenuList
                                autoFocusItem={open}
                                onKeyDown={handleListKeyDown}
                              >
                                <MenuItem
                                  onClick={handleClose}
                                  component={Link}
                                  to="/dash"
                                  className={classes.accountMenuItem}
                                >
                                  <AccountCircleIcon
                                    style={{
                                      marginRight: 12,
                                      fontSize: 18,
                                      color: "#4c004c",
                                    }}
                                  />
                                  Dashboard
                                </MenuItem>
                                <MenuItem
                                  onClick={logout}
                                  className={classes.accountMenuItem}
                                >
                                  <ExitToAppIcon
                                    style={{
                                      marginRight: 12,
                                      fontSize: 18,
                                      color: "#4c004c",
                                    }}
                                  />
                                  Logout
                                </MenuItem>
                              </MenuList>
                            </ClickAwayListener>
                          </Paper>
                        </Grow>
                      )}
                    </Popper>
                  </>
                )}
              </Hidden>

              {/* Mobile menu trigger */}
              <Hidden lgUp>
                <IconButton
                  onClick={() => setDrawerOpen(true)}
                  className={classes.menuButton}
                  aria-label="open menu"
                >
                  <MenuIcon />
                </IconButton>
              </Hidden>
            </Box>
          </Toolbar>
        </Container>

        {/* Full-screen drawer */}
        <Drawer
          anchor="right"
          open={drawerOpen}
          onClose={closeDrawer}
          className={classes.drawer}
          transitionDuration={400}
        >
          <Box className={classes.drawerInner}>
            <Box className={classes.drawerBgAccent} />
            <Box className={classes.drawerBgAccent2} />

            {/* Header */}
            <Box className={classes.drawerHeader}>
              <Link
                to="/"
                onClick={closeDrawer}
                className={classes.logoContainer}
              >
                <Box className={classes.logoWrapper}>
                  <img
                    src="/static/logo.png"
                    alt="Arawinz logo"
                    className={classes.logo}
                  />
                </Box>
                <Typography className={classes.brandName}>Arawinz</Typography>
              </Link>
              <IconButton
                onClick={closeDrawer}
                className={classes.drawerCloseBtn}
                aria-label="close menu"
              >
                <CloseIcon />
              </IconButton>
            </Box>

            {/* Big nav links */}
            <Box className={classes.drawerNav}>
              {NAV_ITEMS.map((item, idx) => {
                const active = isActive(item.path);
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    onClick={closeDrawer}
                    className={`${classes.drawerLink} ${
                      active ? classes.drawerLinkActive : ""
                    }`}
                    style={{ animationDelay: `${idx * 60 + 120}ms` }}
                  >
                    <Typography className={classes.drawerLinkText}>
                      {item.label}
                    </Typography>
                    <ArrowForwardIcon className={classes.drawerLinkArrow} />
                  </Link>
                );
              })}
            </Box>

            {/* Account */}
            {user && (
              <Box className={classes.drawerAccount}>
                <Button
                  ref={anchorRef1}
                  fullWidth
                  onClick={handleToggle1}
                  className={classes.accountButton}
                  style={{ justifyContent: "space-between" }}
                >
                  <span>Account</span>
                  <KeyboardArrowDownIcon />
                </Button>
                <Popper
                  open={open1}
                  anchorEl={anchorRef1.current}
                  role={undefined}
                  transition
                  disablePortal
                >
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin:
                          placement === "bottom"
                            ? "center top"
                            : "center bottom",
                      }}
                    >
                      <Paper style={{ borderRadius: 12, marginTop: 8 }}>
                        <ClickAwayListener onClickAway={handleClose1}>
                          <MenuList
                            autoFocusItem={open1}
                            onKeyDown={handleListKeyDown1}
                          >
                            <MenuItem
                              onClick={handleClose1}
                              component={Link}
                              to="/dash"
                              className={classes.accountMenuItem}
                            >
                              <AccountCircleIcon
                                style={{
                                  marginRight: 12,
                                  fontSize: 18,
                                  color: "#4c004c",
                                }}
                              />
                              Dashboard
                            </MenuItem>
                            <MenuItem
                              onClick={logout}
                              className={classes.accountMenuItem}
                            >
                              <ExitToAppIcon
                                style={{
                                  marginRight: 12,
                                  fontSize: 18,
                                  color: "#4c004c",
                                }}
                              />
                              Logout
                            </MenuItem>
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </Box>
            )}

            {/* Footer CTA */}
            <Box className={classes.drawerFooter}>
              <Button
                component={Link}
                to="/get-in-touch"
                onClick={closeDrawer}
                className={classes.drawerContactButton}
                endIcon={<ArrowForwardIcon />}
              >
                Get in Touch
              </Button>
            </Box>
          </Box>
        </Drawer>
      </AppBar>
    </HideOnScroll>
  );
};
